import Magnify from 'ol-ext/Overlay/Magnify.js'
import {wig25k_magnify, 
    wig100k_magnify, 
    wig300k_magnify, 
    wig500k1939_magnify, 
    wig500k_magnify, 
    gaul_magnify, 
    TKKP_126k_magnify, 
    chrzanowski_magnify, 
    kummersberg_magnify, 
    schroetter_magnify, 
    gilly_magnify, 
    textor_magnify, 
    reymann_magnify, 
    m25k_magnify, 
    kdr_magnify, 
    kdr_gb_magnify, 
    kdwr_magnify, 
    ukvme_magnify, 
    dwuwiorstowka_magnify,
    warszawaNowy_magnify, 
    rauch_magnify, 
    warszawaOKI_magnify, 
    lindley_magnify, 
    warszawa_magnify, 
    bialystok_magnify,
    bieczNowy_magnify,
    bielskNowy_magnify,
    brzescNowy_magnify, 
    bydgoszcz_magnify,
    chelmnoNowy_magnify, 
    czestochowa_magnify, 
    czestochowaNowa_magnify,
    dobrzynNowy_magnify,
    dolskNowy_magnify,
    drohiczynNowy_magnify,
    elblagNowy_magnify,
    gdansk_magnify, 
    gdanskNowy_magnify,
    gnieznoNowy_magnify,
    grudziadz_magnify, 
    inowroclaw_magnify,
    inowroclawNowy_magnify, 
    jaslo_magnify,
    kaliszNowy_magnify, 
    katowice_magnify, 
    kielce_magnify, 
    koscianNowy_magnify,
    wawelNowy_magnify,
    krakow1563Nowy_magnify,
    krakowNowy_magnify,
    krakow_magnify,
    lublin_magnify,
    leczycaNowa_magnify, 
    lodz_magnify,
    malborkNowy_magnify,
    mielnikNowy_magnify,
    mielKrzywNowy_magnify,
    nowySaczNowy_magnify,
    piotrkowNowy_magnify,
    pleszewNowy_magnify,
    plockNowy_magnify, 
    poznan_magnify,
    poznanNowy_magnify, 
    radom_magnify,
    rawaNowy_magnify, 
    rzeszow_magnify,
    sandomierzNowy_magnify, 
    siedlce_magnify,
    sieradzNowy_magnify,
    siewierzNowy_magnify, 
    tarnow_magnify, 
    torun_magnify,
    wegrowNowy_magnify,
    wieliczkaNowy_magnify,
    wielunNowy_magnify,
    wloclawekNowy_magnify, 
    wroclaw_magnify, 
    wschowaNowy_magnify,
    ahp_ziemie_polskie_magnify, 
    ahp_koscielne_magnify, 
    ahp_wlasnosc_magnify, 
    ahp_drogi_magnify, 
    krakowskie18w_magnify, 
    slask18w_magnify,
    osm_magnify} from './source'

export const mapsToMagnify = [wig25k_magnify, 
    wig100k_magnify, 
    wig300k_magnify, 
    wig500k1939_magnify, 
    wig500k_magnify, 
    gaul_magnify, 
    TKKP_126k_magnify, 
    chrzanowski_magnify, 
    kummersberg_magnify, 
    schroetter_magnify, 
    gilly_magnify, 
    textor_magnify, 
    reymann_magnify, 
    m25k_magnify, 
    kdr_magnify, 
    kdr_gb_magnify, 
    kdwr_magnify, 
    ukvme_magnify, 
    dwuwiorstowka_magnify,
    warszawaNowy_magnify, 
    rauch_magnify, 
    warszawaOKI_magnify, 
    lindley_magnify, 
    warszawa_magnify, 
    bialystok_magnify,
    bieczNowy_magnify,
    bielskNowy_magnify,
    brzescNowy_magnify, 
    bydgoszcz_magnify,
    chelmnoNowy_magnify, 
    czestochowa_magnify, 
    czestochowaNowa_magnify,
    dobrzynNowy_magnify,
    dolskNowy_magnify,
    drohiczynNowy_magnify,
    elblagNowy_magnify,
    gdansk_magnify, 
    gdanskNowy_magnify,
    gnieznoNowy_magnify,
    grudziadz_magnify, 
    inowroclaw_magnify,
    inowroclawNowy_magnify, 
    jaslo_magnify,
    kaliszNowy_magnify, 
    katowice_magnify, 
    kielce_magnify, 
    koscianNowy_magnify,
    wawelNowy_magnify,
    krakow1563Nowy_magnify,
    krakowNowy_magnify,
    krakow_magnify,
    lublin_magnify,
    leczycaNowa_magnify, 
    lodz_magnify,
    malborkNowy_magnify,
    mielnikNowy_magnify,
    mielKrzywNowy_magnify,
    nowySaczNowy_magnify,
    piotrkowNowy_magnify,
    pleszewNowy_magnify,
    plockNowy_magnify, 
    poznan_magnify,
    poznanNowy_magnify, 
    radom_magnify,
    rawaNowy_magnify, 
    rzeszow_magnify,
    sandomierzNowy_magnify, 
    siedlce_magnify,
    sieradzNowy_magnify,
    siewierzNowy_magnify, 
    tarnow_magnify, 
    torun_magnify,
    wegrowNowy_magnify,
    wieliczkaNowy_magnify,
    wielunNowy_magnify,
    wloclawekNowy_magnify, 
    wroclaw_magnify, 
    wschowaNowy_magnify,
    ahp_ziemie_polskie_magnify, 
    ahp_koscielne_magnify, 
    ahp_wlasnosc_magnify, 
    ahp_drogi_magnify, 
    krakowskie18w_magnify, 
    slask18w_magnify,
    osm_magnify]

export const magnifiedMaps = new Magnify({
        layers: mapsToMagnify,
        zoomOffset: Number($("#zoom").val()),  //Magnification level
    });
  